export default {"src":"/pro/_next/static/media/aave.03842843.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};